import React, { useEffect } from "react";
import { IoArrowBackSharp } from "react-icons/io5";

const GainCar = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://tuning-shop.com/media/js/iframe-loader.js";
    script.async = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="p-6 min-h-screen">
      <h3 className="text-2xl font-bold mb-4 text-gray-900 dark:text-gray-100 flex items-center">
        {/* Go Back Button */}
        <button
          onClick={() => window.history.back()} // This will navigate back to the previous page
          className="rounded-full hover:bg-gray-200 transition-all mr-2"
        >
          <IoArrowBackSharp size={24} />
        </button>{" "}
        Gain
      </h3>
      <iframe
        src="https://tuning-shop.com/iframe/iframe.php?user=5820"
        width="100%"
        height="auto"
        scrolling="no"
        frameborder="0"
        style={{ border: 0 }}
      ></iframe>
    </div>
  );
};

export default GainCar;
